module.exports = __webpack_public_path__ + "puwenimg3.png?02fa514877fe14b49937db6a8c897e81";